import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IFavouritesConfirmationList} from "../../../favorite/components/FavouritesConfirmationList/favourites_confirmation_list.types";
import {FavouritesConfirmationList} from "../../../favorite/components/FavouritesConfirmationList/FavouritesConfirmationList";

interface IProps {
    confirmationList: IFavouritesConfirmationList;
}

export const AskForAllModalRejectedInfo = (props: IProps) => {
    const {confirmationList} = props;

    return (
        <div css={contentWrap}>
            <FavouritesConfirmationList css={list} confirmationList={confirmationList} />
            <Text variant="body_copy_1" css={bottomText}>
                Możesz ponownie uzupełnić listę i wysłać nowe zapytania.
            </Text>
            <Button variant="filled_primary" href={rpAppLink.base()}>
                Przejdź do strony głównej
            </Button>
        </div>
    );
};

const contentWrap = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${p(5, 1.5, 5, 1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 3, 6, 3)}
    }
`;

const list = (theme: Theme) => css`
    width: 100%;
    ${m(0, 0, 5, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 6, 0)};
    }
`;

const bottomText = (theme: Theme) => css`
    ${m(0, 0, 4, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 3, 0)}
    }
`;
import React from "react";
import {css, Theme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {m, p} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

import {IFavouritesConfirmationList} from "../../../favorite/components/FavouritesConfirmationList/favourites_confirmation_list.types";
import {FavouritesConfirmationList} from "../../../favorite/components/FavouritesConfirmationList/FavouritesConfirmationList";

interface IProps {
    confirmationList: IFavouritesConfirmationList;
}

export const AskForAllModalRejectedInfo = (props: IProps) => {
    const {confirmationList} = props;

    return (
        <div css={contentWrap}>
            <FavouritesConfirmationList css={list} confirmationList={confirmationList} />
            <Text variant="body_copy_1" css={bottomText}>
                Możesz ponownie uzupełnić listę i wysłać nowe zapytania.
            </Text>
            <Button variant="filled_primary" href={rpAppLink.base()}>
                Przejdź do strony głównej
            </Button>
        </div>
    );
};

const contentWrap = (theme: Theme) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    ${p(5, 1.5, 5, 1.5)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${p(3, 3, 6, 3)}
    }
`;

const list = (theme: Theme) => css`
    width: 100%;
    ${m(0, 0, 5, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 6, 0)};
    }
`;

const bottomText = (theme: Theme) => css`
    ${m(0, 0, 4, 0)};

    @media (min-width: ${theme.breakpoints.sm}) {
        ${m(0, 0, 3, 0)}
    }
`;
